import { useEffect } from 'react';
import { useModal } from './index';

const GlobalModalListener = () => {
  const modalStore = useModal();

  useEffect(() => {
    const handler = (event: CustomEvent) => {
      const { modalId } = event.detail;
      modalStore.open(`?modal=${modalId}`);
    };
    window.addEventListener('open-klv-modal', handler as EventListener);
    return () => window.removeEventListener('open-klv-modal', handler as EventListener);
  }, [modalStore]);

  return null;
};

export default GlobalModalListener; 
